/* Effing Gear POD shipping disclosure. Presentation/acknowledgment only; never changes cart or rates. */
(function () {
  'use strict';
  const POD_IDS = new Set(["8533701165141","8533704900693","8533705556053","8533706211413","8533789048917","8535532666965","8535542267989","8535833313365","8536008622165","8536025104469","8536054726741","8536103583829","8545939095637","8548654678101","8548674404437","8548686856277","8548695244885","8548702683221","8548706484309","8548751016021","8548751114325","8548751376469","8548751442005","8548751474773","8548751540309","8548751802453","8548752097365","8548752293973","8548752359509","8549411487829","8549415452757","8549416796245","8549418270805","8549512282197","8549519229013","8552946761813","8552949088341","8553679978581","8553681125461","8553681223765","8553681256533","8583255982165"]);
  function signature(items) {
    return items.filter(item => item.pod).map(item => String(item.key || item.variant_id || item.id) + ':' + Number(item.quantity)).sort().join('|');
  }
  function hasPodTag(tags) {
    return (Array.isArray(tags) ? tags : String(tags || '').split(',')).map(tag => tag.trim()).includes('eg-pod-no-selleasy');
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { signature, hasPodTag }; return; }
  if (window.__egPodCartAckInstalled) return;
  window.__egPodCartAckInstalled = true;
  const copy = 'POD items ship separately with their own shipping charge: $7.95 in the contiguous U.S. or $13.99 to Alaska, Hawaii, and Puerto Rico. The regular-merchandise $60 free-shipping offer does not waive POD shipping. Final shipping is shown at checkout.';
  const checkboxCopy = 'I understand POD has a separate shipping charge, even if my regular merchandise qualifies for free shipping.';
  const checkoutSelector = '.upcart-checkout-button, button[name="checkout"], input[name="checkout"], a[href^="/checkout"]';
  const cartSelector = '.upcart-cart, .quick-cart__form, .cart__form';
  let podSignature = '', acceptedSignature = '', refreshTimer, renderTimer, requestVersion = 0, cartVersion = 0;
  let nextId = 0;
  const productCache = new Map();
  const watched = new WeakSet();
  const observer = new MutationObserver(records => {
    if (records.every(record => record.target.closest && record.target.closest('.eg-pod-cart-ack'))) return;
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, 100);
  });
  const style = document.createElement('style');
  style.textContent = '.eg-pod-cart-ack{margin:12px 0;padding:12px;border:1px solid #d8d8d8;border-left:4px solid #e73838;color:#171717;background:#fff;font-size:13px;line-height:1.45;text-align:left;flex-basis:100%;width:100%;box-sizing:border-box}.eg-pod-cart-ack p{margin:0 0 8px}.eg-pod-cart-ack label{display:flex;gap:8px;align-items:flex-start;cursor:pointer}.eg-pod-cart-ack input{flex:none;width:18px;height:18px;margin:2px 0 0}.eg-pod-cart-error{color:#a30000;margin-top:8px!important}html[data-eg-pod-in-cart="true"] .upcart-cart .upcart-express-pay-container,html[data-eg-pod-in-cart="true"] .upcart-cart .upcart-additional-checkout-buttons,html[data-eg-pod-in-cart="true"] .cart__form .additional-checkout-buttons,html[data-eg-pod-in-cart="true"] .quick-cart__form .additional-checkout-buttons{display:none!important}';
  document.head.appendChild(style);
  function checkoutRoot(button) { return button.closest(cartSelector); }
  function render() {
    document.documentElement.setAttribute('data-eg-pod-in-cart', podSignature ? 'true' : 'false');
    document.querySelectorAll(cartSelector).forEach(root => {
      if (!watched.has(root)) { observer.observe(root, { childList: true, subtree: true }); watched.add(root); }
    });
    document.querySelectorAll(checkoutSelector).forEach(button => {
      const root = checkoutRoot(button);
      if (!root) return;
      // One notice for each cart surface, immediately before its primary checkout.
      let box = root.querySelector('.eg-pod-cart-ack');
      if (!podSignature) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'eg-pod-cart-ack';
        box.setAttribute('role', 'note');
        const title = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = 'POD: separate shipping charge';
        title.appendChild(strong);
        const detail = document.createElement('p');
        detail.textContent = copy;
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.id = 'eg-pod-cart-confirm-' + (++nextId);
        const text = document.createElement('span');
        text.textContent = checkboxCopy;
        label.append(input, text);
        const error = document.createElement('p');
        error.className = 'eg-pod-cart-error';
        error.setAttribute('role', 'alert');
        error.hidden = true;
        error.textContent = 'Please acknowledge the separate POD shipping charge before checkout.';
        box.append(title, detail, label, error);
        input.addEventListener('change', () => {
          acceptedSignature = input.checked ? podSignature : '';
          document.querySelectorAll('.eg-pod-cart-ack input').forEach(other => { other.checked = input.checked; });
          document.querySelectorAll('.eg-pod-cart-error').forEach(node => { node.hidden = true; });
        });
        button.parentNode.insertBefore(box, button);
      }
      box.querySelector('input').checked = acceptedSignature === podSignature;
    });
  }
  async function isPod(item) {
    if (POD_IDS.has(String(item.product_id || item.productId))) return true;
    if (hasPodTag(item.tags || [])) return true;
    const urlMatch = String(item.productUrl || item.url || '').match(/\/products\/([^/?#]+)/);
    const handle = item.handle || (urlMatch && urlMatch[1]);
    if (!handle) return false;
    if (!productCache.has(handle)) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(product => hasPodTag(product.tags)).catch(() => { productCache.delete(handle); return false; }));
    }
    return productCache.get(handle);
  }
  async function refresh() {
    const version = ++requestVersion;
    const observedCartVersion = cartVersion;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (!Array.isArray(cart.items)) return;
      const items = await Promise.all(cart.items.map(async item => ({ ...item, pod: await isPod(item) })));
      if (version !== requestVersion || observedCartVersion !== cartVersion) return;
      const next = signature(items);
      if (next !== podSignature) acceptedSignature = '';
      podSignature = next;
      render();
    } catch (_) { /* Preserve a known disclosure if a transient read fails. */ }
  }
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 120); }
  function applyKnownCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const version = ++cartVersion;
    const known = signature(cart.items.map(item => ({ ...item, pod: POD_IDS.has(String(item.product_id || item.productId)) })));
    if (known !== podSignature) acceptedSignature = '';
    podSignature = known;
    render();
    // Future POD listings are identified by their public product tag, once per handle.
    Promise.all(cart.items.map(async item => ({ ...item, pod: await isPod(item) }))).then(items => {
      if (version !== cartVersion) return;
      const resolved = signature(items);
      if (resolved !== podSignature) acceptedSignature = '';
      podSignature = resolved;
      render();
    });
  }
  function block(event, root) {
    if (!podSignature || acceptedSignature === podSignature) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    render();
    const box = root && root.querySelector('.eg-pod-cart-ack');
    if (box) {
      box.querySelector('.eg-pod-cart-error').hidden = false;
      box.querySelector('input').focus();
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest && event.target.closest(checkoutSelector);
    if (button && checkoutRoot(button)) block(event, checkoutRoot(button));
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('.cart__form,.quick-cart__form') && event.submitter && event.submitter.name === 'checkout') block(event, event.target);
  }, true);
  function receiveCart(event) {
    if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) applyKnownCart(event.detail.cart);
    else scheduleRefresh();
  }
  ['aftersell-upcart:public-events:cart-loaded','aftersell-upcart:public-events:cart-updated','aftersell-upcart:public-events:cart-opened'].forEach(name => window.addEventListener(name, receiveCart));
  ['cart:updated','cart:item-added','ajaxProduct:added'].forEach(name => document.addEventListener(name, receiveCart));
  document.addEventListener('click', event => {
    if (event.target.closest && event.target.closest('a[href="/cart"],[data-open-cart],.upcart-open-cart-button')) scheduleRefresh();
  });
  applyKnownCart(window.upcartPreloadedCart);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { render(); if (!window.upcartPreloadedCart) scheduleRefresh(); }, { once: true });
  else { render(); if (!window.upcartPreloadedCart) scheduleRefresh(); }
})();
